import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import * as fileUpload from 'fuctbase64';
import { SemsoSnackbarService } from '../semso-snackbar.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

    _file;
    _name = 'Bijlage';
    _baseFile;

    @Output() change = new EventEmitter();

    @Output() fileChange = new EventEmitter();

    @Input() get file() {
        return this._file;
    }
    set file(val) {
        this._file = val;
        this.fileChange.emit(this._file);
    }

    @Output() nameChange = new EventEmitter();
    @Input() get name() {
        return this._name;
    }

    set name(val) {
        this._name = val;
        this.nameChange.emit(this._name);
    }

    constructor(private snackbar: SemsoSnackbarService) { }

    ngOnInit() {
        if (this.file != null && this.file.length > 0) {
            fetch(`data:image;base64,${this.file}`).then(res => res.blob())
                .then((blob: Blob) => {
                    this._baseFile = new File([blob], this._name);
                });
        }
    }

    upload(event) {
        fileUpload(event).then(res => {
            if (res.type == "image/png" || res.type == "image/jpeg" || res.type == "image/jpg") {

                this.file = res.base64;
                this.name = res.name;
                this._baseFile = res;
                this.change.emit();
            } else {
                this.snackbar.error("Alleen afbeeldingen (*.png, *.jpeg, *.jpg) zijn toegestaan.");
            }
        });
    }

    remove() {
        this.file = null;
        this.name = null;
        this._baseFile = null;
        this.change.emit();
    }

}



// WEBPACK FOOTER //
// ./src/app/file-upload/file-upload.component.ts